import { render, staticRenderFns } from "./PendingActivityCard.vue?vue&type=template&id=379fd784&scoped=true&"
import script from "./PendingActivityCard.vue?vue&type=script&lang=js&"
export * from "./PendingActivityCard.vue?vue&type=script&lang=js&"
import style0 from "./PendingActivityCard.vue?vue&type=style&index=0&id=379fd784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379fd784",
  null
  
)

export default component.exports